import React from "react";
import { CiImport } from "react-icons/ci";
import { FaPlusCircle, FaFileUpload } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ExpenseHeader = () => {
  const navigate = useNavigate();

  const handleNewExpense = () => {
    navigate("/Invoice/NewInvoice");
  };

  const handleImport = () => {
    navigate("/Import/invoice", {
      state: { title: "Invoice" },
    });
  };

  const handleBulkImport = () => {
    navigate("/invoice/bulk-import");
  };

  return (
    <div className="flex items-center justify-between px-4 bg-white shadow rounded-lg h-[70px] mb-4">
      <div>
        <span className="text-gray-700 font-semibold text-lg">All Invoice</span>
      </div>

      {/* Spacer to move the buttons to the right */}
      <div className="ml-auto flex items-center space-x-4">
        {/* Notification Icon */}
        {/* <div className="relative">
          <button className="flex items-center justify-center p-2 bg-yellow-100 rounded-full">
            <svg
              className="h-8 w-8 text-yellow-500"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <path d="M9 7h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3" />
              <circle cx="16" cy="8" r="3" />
            </svg>
          </button>
          <span className="absolute top-0 right-0 bg-blue-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
            1
          </span>
        </div> */}

        <button
          onClick={handleNewExpense}
          className="flex items-center justify-center gap-x-2 py-2 px-4 bg-primary text-white rounded-lg hover:bg-blue-600 shadow-sm ml-auto"
        >
          <FaPlusCircle className="text-white text-[18px]" />
          <p className="text-sm">New</p>
        </button>
        <button
          onClick={handleImport}
          className="flex items-center justify-center gap-x-2 py-2 px-4 bg-primary text-white rounded-lg hover:bg-blue-600 shadow-sm  ml-auto"
        >
          <CiImport className="text-white text-[20px]" />
          <p className="text-sm">Import Items</p>
        </button>
        <button
          onClick={handleBulkImport}
          className="flex items-center justify-center gap-x-2 py-2 px-4 bg-primary text-white rounded-lg hover:bg-blue-600 shadow-sm"
        >
          <FaFileUpload className="text-white text-[16px]" />
          <p className="text-sm">Bulk Import</p>
        </button>
      </div>
    </div>
  );
};

export default ExpenseHeader;
